import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Tooltip } from '@interstate/components/Tooltip';
import { useProgramField } from '@makemydeal/dr-dash-components';

import { useSummaryFieldLinks } from '../../../../baseDealActivity/baseDealContainer/hooks/useSummaryFieldLinks';
import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { LabelWithInfo, ReadOnlyValue } from '../../../ScenarioGrid.style';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';

export const LENDER_PROGRAM_LABEL = 'Lender Program';

export const LenderProgramRow = () => {
    const theme = useInterstateTheme();
    const { openIncentivesFromProgram } = useSummaryFieldLinks();
    const { value, upqWarning, onLabelActivate } = useProgramField({ onProgramSlideOutOpen: openIncentivesFromProgram });
    const cellId = useScenarioCellId('lenderProgram');

    return (
        <ScenarioRow
            rowKey="lenderProgram"
            label={
                <LabelWithInfo>
                    <RowLabelAction onActivate={onLabelActivate} testId="program-field-label">
                        {LENDER_PROGRAM_LABEL}
                    </RowLabelAction>
                    {upqWarning && (
                        <Tooltip
                            id={`${cellId}-upq-warning-tooltip`}
                            data-testid="program-upq-warning-tooltip"
                            toolTipContent={upqWarning}
                            position="bottom"
                            size="large"
                        >
                            <span tabIndex={0} aria-label={upqWarning} data-testid="program-upq-warning-tap-target">
                                <InformationCircleIcon
                                    data-testid="program-upq-warning-icon"
                                    color={theme.tokens.BaseColorBlue500}
                                    aria-hidden
                                />
                            </span>
                        </Tooltip>
                    )}
                </LabelWithInfo>
            }
        >
            <ReadOnlyValue id={cellId} data-testid="program-field">
                {value}
            </ReadOnlyValue>
        </ScenarioRow>
    );
};
